import type { SubmitLeadDto, SubmitLeadResultDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LeadService {
  apiName = 'Default';


  submitLead = (input: SubmitLeadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SubmitLeadResultDto>({
      method: 'POST',
      url: '/api/app/lead/submit-lead',
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
